export const convertToWebP = (file, quality = 0.8) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const imageUrl = URL.createObjectURL(file);

    image.onload = () => {
      const canvas = document.createElement("canvas");

      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;

      const context = canvas.getContext("2d");
      context.drawImage(image, 0, 0);

      canvas.toBlob(
        (blob) => {
          URL.revokeObjectURL(imageUrl);

          if (!blob) {
            reject(new Error("Image conversion failed"));
            return;
          }

          const webpFile = new File(
            [blob],
            `${file.name.replace(/\.[^.]+$/, "")}.webp`,
            { type: "image/webp" }
          );

          resolve(webpFile);
        },
        "image/webp",
        quality
      );
    };

    image.onerror = () => {
      URL.revokeObjectURL(imageUrl);
      reject(new Error("Invalid image file"));
    };

    image.src = imageUrl;
  });
};

const SKIP_TYPES = ["image/webp", "image/gif", "image/svg+xml"];

const isConvertibleImage = (value) =>
  value instanceof Blob &&
  value.type.startsWith("image/") &&
  !SKIP_TYPES.includes(value.type);


const toWebPOrOriginal = async (value) => {
  try {
    const file =
      value instanceof File
        ? value
        : new File([value], "image", { type: value.type });
    const webpFile = await convertToWebP(file);
    return webpFile.type === "image/webp" ? webpFile : value;
  } catch (error) {
    return value;
  }
};

export const convertFormDataImagesToWebP = async (formData) => {
  const entries = Array.from(formData.entries());
  if (!entries.some(([, value]) => isConvertibleImage(value))) return formData;

  const converted = new FormData();
  for (const [key, value] of entries) {
    converted.append(
      key,
      isConvertibleImage(value) ? await toWebPOrOriginal(value) : value
    );
  }
  return converted;
};


export const registerWebPUploadInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.request.use(async (config) => {
    if (config.data instanceof FormData) {
      config.data = await convertFormDataImagesToWebP(config.data);
    }
    return config;
  });
};
